export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[4-9])|([1-4][0-9])|([56][0-8])|(7[0-5])|([89][0-7]))[0-9]{2}$/i));
    }
}
